export default "__VITE_ASSET__CwztUE5Q__"